export default "__VITE_ASSET__DVnWWW6f__"